export default {
  message: {
    "error": "Uy! May nangyaring mali.",
    "Sorrysomeerrorsoccurred": "May hindi inaasahang error na nangyari. Maaari mong subukang palitan ang wika o lumabas at i-restart ang app.",
    "quit": "Tumigil",
    "language": "Wika",
    "Youcanchangethelanguagehere": "Maaari mong baguhin ang wika dito!",
    "current": "Kasalukuyan",
    "home": "Bahay",
    "friends": "Mga Kaibigan",
    "wallet": "Wallet",
    "aboutus": "Tungkol sa Amin",
    "Sharewithfriends": "Ibahagi sa mga kaibigan",
    "copyFailure": "Kopya Nabigo",
    "copySuccess": "Kopya Matagumpay",
    "Claimreward": "Kumuha ng gantimpala",
    "DailyLogin": "Pang-araw-araw na Pag-login",
    "noInvitationsYet": "Walang Imbitasyon Pa",
    "LoadMore": "Mag-load ng Higit Pa",
    "WatchAD": "Manood ng AD",
    "continue": "Magpatuloy",
    "Congratulations": "Binabati kita",
    "MyFriends": "Ang mga Kaibigan Ko",
    "Invitefriends": "Mag-imbita ng mga kaibigan",
    "Invitepremiumfriends": "Mag-imbita ng mga premium na kaibigan",
    "DailyTasks": "Pang-araw-araw na mga gawain",
    "inviteDesc": "+{num} ${name} para sa bawat kaibigan na iyong iniimbitahan",
    "DailyTasksDesc": "Kumpletuhin ang mga gawain upang makakuha ng higit pang airdrop",
    "SponsorsandPartners": "Mga Sponsor at Kasosyo",
    "Receivingwallet": "Pagtanggap ng wallet",
    "Enterwalletaddress": "Ilagay ang {name} wallet address",
    "Claim": "Kumuha",
    "Booster": "Booster",
    "RentPeriod": "Panahon ng Upa",
    "days30": "30 araw",
    "Dailyprofit": "Pang-araw-araw na kita",
    "Totalprofit": "Kabuuang kita",
    "Quantity": "Dami",
    "RentPrice": "Presyo ng Upa",
    "RentMiner": "Uminom ng Miner",
    "Insufficient": "Kulang sa mga naimbitahang tao",
    "InsufficientMsg": "Kailangan mong mag-imbita ng {num} na kaibigan upang kumita ng higit pang accessories.",
    "Settings": "Mga Setting",
    "copyid": "Kopyahin ang ID",
    "UpgradeSuccessfully": "Matagumpay na Nag-upgrade",
    "Name": "Pangalan",
    "userinfo": "Impormasyon ng Gumagamit",
    "disconnect": "Ikonekta",
    "Startmining": "Simulan ang pagmimina",
    "Welcome": "Maligayang pagdating sa {name}",
    "Withdrawal": "Pag-withdraw",
    "Minimumamount": "Minimun na halaga",
    "Networkfee": "Bayad ng network",
    "Enteramount": "Ilagay ang halaga",
    "Submit": "I-submit",
    "MinimumTip": "Ang halaga ng withdrawal ay masyadong maliit. Minimum na halaga ng withdrawal: {num}",
    "MaximumTip": "Kulang ang halaga, ang maximum na halaga na maaari mong i-withdraw ay: {num}",
    "SubmittedTip": "Naisumite, inaasahang iproseso sa loob ng 30-60 araw ng trabaho",
    "WebSubmittedTip": "Naisumite, iproseso namin ito sa lalong madaling panahon.",
    "WithdrawStatus": "Status",
    "Submissiontime": "Oras ng pagsusumite",
    "WithdrawAwaitTip": "* Tinatayang aabutin ng 30-60 araw ng trabaho. Ang pag-imbita ng mas maraming kaibigan ay maaaring pabilisin ang proseso ng pagsusuri.",
    "WebWithdrawAwaitTip": "* Tinatayang aabutin ng 24-48 oras. Ang pag-imbita ng mas maraming kaibigan ay maaaring pabilisin ang proseso ng pagsusuri.",
    "Processing": "Pinoproseso",
    "Success": "Tagumpay",
    "Rejection": "Pagtanggi",
    "Amount": "Halaga",
    "Numberoffriends": "Bilangan ng mga kaibigan: {now}/{limit}",
    "InviteTip": "Upang makagawa ng iyong unang withdrawal, kailangan mong imbitahan ang {limit} na mga kaibigan na sumali sa mining app.",
    "openonphone": "Buksan ang link na ito sa iyong telepono.",
    "claimTip": "Ang halagang makokolekta ay masyadong maliit. Ang minimum na halagang makokolekta ay: {num}",
    "WalletBalance": "Balanseng Wallet",
    "Withdraw": "Mag-withdraw",
    "SetWalletAddress": "Itakda ang Wallet Address",
    "WithdrawalRecord": "Tala ng Withdrawal",
    "Norecords": "Walang tala",
    "Whatis": "Ano ang {name}?",
    "All": "Lahat",
    "save": "I-save",
    "successWithdrawal": "Tagumpay sa pag-scan {num}",
    "secondsago": "{time} segundo ang nakalipas",
    "Loading": "Naglo-load...",
    "PaymentConfirming": "Sinusuri ang Status ng Transaksyon...",
    "Check": "Suriin",
    "CheckFail": "Hindi natapos ang transaksyon. Mangyaring suriin muli sa loob ng 5 segundo.",
    "Addname": "Idagdag ang '{name}' sa iyong pangalan",
    "Restattcheck": "I-restart ang app upang suriin",
    "Copyname": "Kopyahin ang '{name}'",
    "SubmissionFailed": "Nabigo ang pagsusumite, mangyaring subukan muli sa ibang pagkakataon",
    "WithdrawalReview": "Suriin ang withdrawal",
    "select_payment_method": "Pumili ng paraan ng pagbabayad",
    "total_amount": "Kabuuang halaga",
    "next_step": "Susunod na hakbang",
    "creating_order": "Gumagawa ng order...",
    "order_created": "Mag-order na nalikha",
    "order_status": "Status ng order",
    "order_id": "Order ID",
    "order_amount": "Halaga ng order",
    "order_status_desc": "Paglalarawan ng status ng order",
    "payment_cancelled": "Na-kansela ang pagbabayad",
    "opening_payment": "Binubuksan ang pagbabayad...",
    "payment_success": "Matagumpay ang pagbabayad",
    "payment_failed": "nabigong pagbabayad",
    "payment_pending": "nakabinbing pagbabayad",
    "payment_processing": "pinoprosesong pagbabayad",
    "create_order_failed": "nabigong lumikha ng order",
    "creating_ton_order": "Naghahanda ng TON order...",
    "check_payment_status": "Tinutukoy ang katayuan ng pagbabayad...",
    "use_ton_payment": "Gamitin ang TON pagbabayad",
    "connect_wallet": "Ikonekta ang wallet",
    "start_transaction": "Simulan ang transaksyon",
    "address": "Address",
    "amount_ton": "Halaga TON",
    "copy": "Kopyahin",
    "comment_memo": "Komentaryo memo",
    "comment_memo_desc": "Mangyaring ilagay ang komentaryong memo",
    "comment_memo_placeholder": "Ilagay ang komentaryong memo",
    "amount": "Halaga",
    "wallet_address": "Wallet address",
    "you_can_choose_to_connect_wallet_to_pay": "Maaari kang pumili na ikonekta ang wallet upang magbayad",
    "or_manually_transfer_to_the_above_address": "O manu-manong ilipat sa itaas na address (tandaan na ang halaga at memo ay dapat na eksaktong pareho)",
    "transaction_success": "Tagumpay sa transaksyon",
    "transaction_failed": "Nabigong transaksyon",
    "transaction_error": "Error sa transaksyon",
    "transaction_status": "Katayuan ng transaksyon",
    "transaction_id": "Transaksyon ID",
    "transaction_amount": "Halaga ng transaksyon",
    "transaction_status_desc": "Paglalarawan ng katayuan ng transaksyon",
    "miner_detail": "Detalye ng minero",
    "rent_period": "Panahon ng pagrenta",
    "days": "{days} araw",
    "daily_yield": "Araw-araw na kita",
    "total_yield": "Kabuuang kita",
    "invite_friends": "Mag-imbita ng mga kaibigan",
    "price": "Presyo",
    "rent": "Upa",
    "free_claim": "Libreng kumpirmahin",
    "redeem": "Bawiin",
    "buy": "Upa",
    "invite_friends_not_enough": "Hindi sapat ang pag-imbita ng mga kaibigan",
    "redeem_success": "Tagumpay sa pagbawi",
    "redeem_failed": "Nabigong pagbawi",
    "rent_success": "Tagumpay sa pagrenta",
    "rent_failed": "Nabigong pagrenta",
    "TotalPower": "Kabuuang Lakas",
    "MaxQuantity": "Naabot na ang maksimum na halaga",
    "Running": "Tumatakbo",
    "Stop": "Itigil",
    "Withdrawalunlock": "Pagbukas ng pag-withdraw",
    "Close": "Isara",
    "Delivering": "Naghahatid",
    "Duetothelargenumber": "Dahil sa malaking bilang ng mga tumanggap, inaasahang darating ang iyong airdrop sa loob ng 15-20 araw ng trabaho",
    "WithdrawalunlockTip": "Kailangan mo ng {num} na inanyayahang kaibigan upang kumpletuhin ang mga gawain/i-bind ang mga wallet upang ma-unlock ang pag-withdraw",
    "mining_title": "Robot",
    "Upgrade": "Mag-upgrade",
    "partner": "Kasosyo",
    "faq": "Mga Tanong",
    "task": "Task",
    "OpenRobot": "Bukas na Robot",
    "MyRobot": "Aking Robot",
    "Level": "Antas",
    "Commission": "Komisyon",
    "DirectFriends": "Direktang Kaibigan",
    "Feedback": "Feedback",
    "Pleaseenteryouremailaddress": "Pakisulat ang iyong email address",
    "Inputfeedbackcontent": "Ipasok ang nilalaman ng feedback",
    "Submitfeedback": "I-submit ang feedback",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Matagumpay na naipasa ang feedback, salamat sa iyong mahalagang feedback",
    "Feedbacksubmissionfailed,pleaseretriy": "Failed ang pagsusumite ng feedback, pakisubukan muli",
    "Addressformaterror": "Pagkakamali sa format ng address",
    "Readclipboardfailed": "Nabigong basahin ang clipboard",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Na-feedback mo na ngayong araw, pakibalik bukas",
    "Record": "Tala",
    "Newuserguidance": "Tignan ang Welcome Tour",
    "Usetonwallet": "Gamitin ang TON wallet",
    "Reward": "Gantimpala",
    "Connectwallet": "I-konekta ang wallet",
    "Notconnected": "Hindi nakakonekta",
    "Disconnect": "Idiskonekta",
    "AboutTAI": "Mga Detalye ng Token",
    "WithdrawalRecordDesc": "Tala ng withdrawal",
    "StartAItrading": "Simulan ang AI trading",
    "Next": "Sulong",
    "Start": "Simulan",
    "WithdrawalSuccess": "Matagumpay ang withdrawal",
    "WithdrawalFail": "Bigong withdrawal",
    "Max": "Max",
    "WithdrawalRecords": "Tala ng Withdrawal",
    "Commissionrules": "Mga patakaran sa komisyon",
    "Mycommission": "Ang aking komisyon",
    "Shop": "Bumili",
    "BuyDifferentAIrobots": "I-upgrade gamit ang mga compute device para sa mas mabilis na skan!",
    "CurrentRunningAIrobots": "Kasalukuyang tumatakbong AI robots",
    "DailyProfit": "Araw-araw na kita",
    "Buy": "Bumili",
    "ValidityPeriod": "Panahon ng bisa",
    "Days": "Araw",
    "Price": "Presyo",
    "APY": "APY",
    "NoRobot": "Walang compute power",
    "RemainingTime": "Natitirang oras",
    "InviteandEarn": "Mag-imbita at kumita",
    "InvitDec": "Imbitahan ang iyong mga kaibigan na sumali sa AI trading at kumita ng USDT commissions at airdrop tokens nang magkasama!",
    "ShareToGroups": "Ibahagi sa mga grupo",
    "Select_payment_method": "Pumili ng paraan ng pagbabayad",
    "twa_pay_tip_with_memo": "Pakisigurado na ang address, halaga, at memo ay pare-pareho para sa transfer.",
    "twa_pay_tip": "Pakisigurado na ang address at halaga ay tama para sa transfer.",
    "twa_pay_tip_placeholder": "Ilagay ang tala ng komento",
    "twa_pay_tip_placeholder_with_memo": "Ilagay ang tala ng komento na may tala",
    "twa_pay_tip_placeholder_without_memo": "Ilagay ang tala ng komento na walang tala",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Ilagay ang tala ng komento na may tala",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Ilagay ang tala ng komento na walang tala",
    "realtime_ai": "Tunay na Oras na AI Trading",
    "check_transaction_status": "Suriin ang katayuan ng transaksyon",
    "transaction_wait": "Ang transaksyon ay pinoproseso. Maaari kang lumabas sa app. Isang mensahe ang magbibigay-alam sa iyo kapag ito ay kumpleto na.",
    "Pleaseenteravalidemailaddress": "Pakisuyo na ilagay ang wastong address ng email",
    "max_robot_tip": "Naabot ang limitasyon sa pagbili — subukan ang ibang plano upang magpatuloy sa pangangalakal!",
    "connectFailure": "Bigong kumonekta sa wallet",
    "connectSuccess": "Matagumpay na kumonekta sa wallet",
    "PayNow": "Magbayad Ngayon",
    "min_withdrawal_amount": "Ang minimum na halaga ng withdrawal ay {num} {coin_name}",
    "max_withdrawal_amount": "Ang maximum na halaga ng withdrawal ay {num} {coin_name}",
    "balance_not_enough": "Wala kang sapat na balanse para sa withdrawal na ito.",
    "Numberofgroups": "Bilangan ng mga grupo: {now}/{limit}",
    "Withdraw_success": "Matagumpay na withdrawal",
    "allProfit": "Kabuuang kita",
    "AnnualProfit": "Taunang kita",
    "ScanWallet": "I-scan ang Wallet",
    "wallet_check": "wallet_check",
    "Found": "Nakita",
    "ScanSpeed": "Bil Speed",
    "MyComputingPower": "Compute",
    "Scanning": "Nagsusuri!",
    "WithdrawDetail": "Detalye ng pag-withdraw",
    "ScanSuccess": "Umakyat ang iyong rate ng tagumpay sa pag-scan!",
    "TaskDescription": "Kumpletuhin ang mga gawain upang madagdagan ang iyong tagumpay sa pag-scan!",
    "InitializingMiningSystem": "Ini-initialisa ang sistema ng pag-scan...",
    "NoWithdrawalRecord": "Walang rekord ng withdrawal",
    "Invite": "Kailangang imbitasyon",
    "Free": "Libre",
    "Confirm": "Kumpirmahin",
    "RefreshTasks": "I-refresh ang mga gawain",
    "NumberofGroups": "Bilang ng grupo: {now}/{limit}",
    "SendMessage": "Magpadala ng mensahe",
    "NumberofShares": "Bilang ng bahagi: {now}/{limit}",
    "NumberofTasks": "Bilang ng mga gawain: {now}/{limit}",
    "CompleteTask": "kumpletuhin ang gawain",
    "Accelerated": "Pinabilis",
    "Accelerated_withdrawals_success": "Matagumpay na pinabilis na pag-withdraw",
    "GoBuy": "Magsimula nang Bumili",
    "SpeedUpScan": "Pabilisin",
    "Earnings": "Kita",
    "learnMore": "Alamin pang marami",
    "claimSuccess": "Nakatanggap ng gantimpala ng matagumpay",
    "claimFailed": "Nabigo ang pagtanggap, pakisubukang muli",
    "noDividends": "Walang dividend na makukuha",
    "dividendsInfoFallback": "Mag-imbita ng mga kaibigan upang kumita ng gantimpalang referral"
}};